import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { ResumenData } from '../../../../core/model/DataCart';
import { OrderArticulos } from '../../../../core/model/DataOrder';
import { LoginService } from '../../../../services/login/login.service';
import { MatDialog } from '@angular/material/dialog';
import { CartService } from '../../../../services/generar-pedido/cart/cart.service';
import { CheckoutService } from './utils/services/checkout.service';
import { EventService } from '../../../../services/event.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ProductData } from '../../../../core/model/Product.model';
import { ListProductCartComponent } from './list-product-cart/list-product-cart.component';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { NotificacionesService } from '../../../../services/generar-pedido/cart/notifications/notificaciones.service';
import { EmpresaService } from '../../../../services/Empresa/Empresa.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements OnInit {
  public resumen: ResumenData = null;
  public orderArticulos: OrderArticulos;
  public cantidadItems = 0;
  private unsubscribe$ = new Subject<void>();
  public data = false;
  public isArticulosCedis: boolean;
  public articulosSinExistencias: string;
  public precioEnvio = 0;
  @ViewChild('childComponent') childComponent: ListProductCartComponent;
  itemsOrder$: Observable<any>;
  private suscriptions: any = [];
  cargando: boolean = false;
  empresaId: number = 1;
  tituloSucursal: string;

  constructor(
    private loginService: LoginService,
    private empresaService: EmpresaService,
    private cartService: CartService,
    private checkoutService: CheckoutService,
    private dialogConfirm: MatDialog,
    private eventService: EventService,
    private notificacionesService: NotificacionesService
  ) { }

  ngAfterViewInit() {
    if (!this.loginService.isLogged()) {
      this.childComponent.addStyleToElement();
    }
  }

  ngOnDestroy(): void {
    this.cartService.goToCart.next(null);
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    if (this.suscriptions[0]) {
      this.suscriptions[0].unsubscribe();
    }
  }

  ngOnInit(): void {
    this.cargando = true
    this.suscriptions[0] = this.eventService.get("updCart").subscribe((data: any) => {
      //console.log("que data es esta", data)
      // Se obtienen articulos del carrito
      this.orderArticulos = data;
    });

    this.empresaId = this.empresaService.getEmpresaId();

    if(this.empresaId == 1) {
      this.tituloSucursal = 'Datos de Envío de Mercancía de Tampico'
    } else {
      this.tituloSucursal = 'Datos de Envío de Mercancía de ' + this.loginService.getDataClientePedido().sucursal
    }

    this.notificacionesService.getNotificacionPuntosKabikCoins().subscribe((res) => {
      // Sirve para obtener los kabicoins
    });

    setTimeout(() => {
      if (this.loginService.getDataClientePedido().es_publicogeneral === 'SI')
        this.childComponent.addStyleToElement();
    }, 3500)

    this.switchCartData();
    this.dataCart();
    this.actualizarPrecioEnvioPaqueteria();
  }

  public deleteCart = () => {
    const dialogRes = this.dialogConfirm.open(DialogConfirmComponent, {
      data: {
        title: '¿Estas seguro que deseas vaciar tu cesta?',
        text: '',
        subtext: '',
        btnPrimaryText: 'Sí, Vaciar',
        btnSecondText: 'No, Cancelar',
        classCancelSecond: true,
        classbtnSecond: true,
        showCancel: true,
        classCustomText: ''
      }
    });
    dialogRes.afterClosed().pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
      if (response) {
        if (this.loginService.isLogged()) {
          this.cartService.deleteCart();
        } else {
          this.cartService.deleteCartIsNotLoguin(); //vaciar cesta cuano no ha iniciado session
        }
        localStorage.removeItem('resumen-cart-login');
        localStorage.removeItem('data-pedido');
        localStorage.removeItem('carrito');
        localStorage.removeItem('items-cart-login');
        localStorage.removeItem('comision-cart-login');
        localStorage.removeItem('pasarela-pago');
        localStorage.removeItem('envio-cart-login');
        localStorage.removeItem('data-operation');
      }
    });
  }

  public selectCFDI = (event) => {
    localStorage.setItem('cliente-CFDI', event);
  }

  private actualizarPrecioEnvioPaqueteria = () => {
    let envioPaqueteriaCedis: boolean = false;
    let envioPaqueteriaSucursal: boolean = false;
    let tipoEnvioSucursal: string = '';
    let tipoEnvioCedis: string = '';
    this.cartService.precioEnvio$.pipe(takeUntil(this.unsubscribe$),
      switchMap((precioEnvio: number) => {
        // console.log('Checkout es el precio de envio: $',precioEnvio);
        // Optenemos el precio del envio.
        this.precioEnvio = precioEnvio;
        // Regresamos la informacion y validamos para cobrarle la paqueteria al cliente.
        return this.checkoutService.getEnvioMercanciaSucursal$().pipe(takeUntil(this.unsubscribe$));
      }),
      switchMap((envioSucursal: { direccionSeleccionada, opcionEnvio, mensaje, direccionEnvio }) => {
        // Regresamos la informacion y validamos para cobrarle la paqueteria al cliente.
        // console.log('Envio sucursal emit', envioSucursal);
        envioPaqueteriaSucursal = envioSucursal.opcionEnvio == 'envio' || envioSucursal.opcionEnvio == 'envioDomicilio' ? true : false;
        tipoEnvioSucursal = envioSucursal.opcionEnvio;
        return this.checkoutService.getEnvioMercanciaCedis$().pipe(takeUntil(this.unsubscribe$));
      }),
      switchMap((envioCedis: { direccionSeleccionada, opcionEnvio, mensaje, direccionEnvio }) => {

        // console.log('Envio Cedis emit', envioCedis);
        envioPaqueteriaCedis = envioCedis.opcionEnvio == 'envio' ? true : false;
        tipoEnvioCedis = envioCedis.opcionEnvio;
        return of('Recalcular el resumen.')
      })
    ).subscribe((actualiza: string) => {
      let precioDelEnvio: number = 0;
      // cobramos la paqueteria.
      //Cambiar esta validacion si se requiere cobrar la paqueteria en el almacen de cedis.
      if (envioPaqueteriaSucursal || envioPaqueteriaCedis) {
        precioDelEnvio = this.precioEnvio;
      } else {
        precioDelEnvio = 0;
      }
      const preciosEnvio = { envio: String(precioDelEnvio), checkCedis: envioPaqueteriaCedis, checkSucursal: envioPaqueteriaSucursal, tipoEnvioSucursal, tipoEnvioCedis };
      localStorage.setItem('opcion-metodo-entrega', JSON.stringify(preciosEnvio));
      localStorage.setItem('envio-cart-login', String(precioDelEnvio));
      const items: ProductData[] = JSON.parse(localStorage.getItem('items-cart-login'));
      this.cartService.calcularResumen(items);
      this.checkoutService.addRecalculaResumen$(true); // Recalculmos el resumen de credito para realizar la validacion del limite de credito.
    },
      error => { console.log(error) },
      () => {
        console.log('complete');
      }
    );
  }

  private switchCartData = () => {
    if (this.loginService.isLogged()) {
      this.getDataCarrito();
    } else {
      this.getDataCarritoInvitado();
    }
  }

  public getDataCarrito = () => {
    this.cartService.getminiCart().pipe(
      takeUntil(this.unsubscribe$)).subscribe((dataResponse) => {
        if (dataResponse.respuesta !== null) {
          localStorage.setItem('carrito', JSON.stringify(dataResponse));
          this.resumen = this.cartService.calcularResumen(dataResponse.respuesta);
          this.cantidadItems = dataResponse.respuesta.length;
          this.articulosSinExistencias = dataResponse.articuloSinExistencias;
          this.cargando = false;
          return true; // dataResponse.respuesta;
        }
        this.cantidadItems = 0;
        this.cargando = false;
        return false;
      }
      );
  }

  private getDataCarritoInvitado = () => {
    const data = JSON.parse(localStorage.getItem('items-cart-login'));
    if (data !== null) {
      this.cartService.getminiCartInvitado();
      this.resumen = this.cartService.calcularResumen(null);
      this.cantidadItems = data.length;
    }
  }

  public dataCart = (): void => {
    this.cartService.cart$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(data => {
      if (data) {
        this.data = true;
        this.cantidadItems = data.length;
        this.resumen = this.cartService.calcularResumen(data);
        if (this.loginService.isLogged() || data.length > 0) {
          localStorage.setItem('items-cart-login', JSON.stringify(data));
          localStorage.setItem('resumen-cart-login', JSON.stringify(this.resumen));
          const resultado = data.find(item => item.isCedis === true);
          this.isArticulosCedis = resultado != undefined || resultado != null ? true : false;
        }
      }
    });
  }
}
